function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var DS = window.WinBoostAiDesignSystem_0f78b0 || {};
var Button = DS.Button,
  Card = DS.Card,
  Badge = DS.Badge,
  CheckItem = DS.CheckItem,
  SectionLabel = DS.SectionLabel,
  Icon = DS.Icon,
  StatBlock = DS.StatBlock,
  Field = DS.Field,
  PatternBackdrop = DS.PatternBackdrop,
  Orbit = DS.Orbit;
function calcMoney(n) {
  return Math.round(n).toLocaleString('fr-CA') + "\u00a0$";
}
function Calculator() {
  var _React$useState = React.useState(1200),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    value = _React$useState2[0],
    setValue = _React$useState2[1];
  var _React$useState3 = React.useState(45),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    missed = _React$useState4[0],
    setMissed = _React$useState4[1];
  var _React$useState5 = React.useState(35),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    close = _React$useState6[0],
    setClose = _React$useState6[1];
  var bookings = missed * (close / 100);
  var perMonth = bookings * value;
  var rows = [['Par semaine', perMonth / 4.33, bookings / 4.33], ['Par mois', perMonth, bookings], ['Par ann\u00e9e', perMonth * 12, bookings * 12], ['Apr\u00e8s 3 ans', perMonth * 36, bookings * 36]];
  return React.createElement(Section, {
    id: "calculator"
  }, React.createElement(InkBand, {
    tone: "dust",
    pad: "clamp(36px,3.8vw,64px) clamp(28px,3.2vw,56px)"
  }, React.createElement("style", null, '#calculator .lead,#calculator .wb-label,#calculator .wb-label *,#calculator [style*="--text-inverse-muted"]{color:var(--wb-cream)!important;opacity:1}#calculator{--surface-card-inverse:rgba(64,32,20,.93);--border-inverse:rgba(255,214,170,.2);--wb-charcoal:#2E1810;--ink-900:#2E1810;--text-inverse-muted:#EBD3BE}'), React.createElement(Head, {
    index: "08",
    label: "Calculateur d\u2019occasions",
    title: "Combien vous co\u00fbtent les occasions manqu\u00e9es?",
    lead: "Estimez le revenu qui dort dans les appels auxquels votre entreprise ne r\u00e9pond pas aujourd\u2019hui.",
    inverse: true
  }), React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr 1.15fr',
      gap: 56,
      alignItems: 'start'
    }
  }, React.createElement(Card, {
    surface: "inverse",
    padding: "lg",
    radius: "xl"
  }, React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 28
    }
  }, React.createElement("span", {
    className: "mono",
    style: {
      color: 'var(--wb-gold)',
      letterSpacing: '.14em',
      fontSize: 11
    }
  }, "ENTREZ VOS PROPRES CHIFFRES"), [['Valeur moyenne d\u2019un client', value, setValue, 200, 10000, 100, '$', ''], ['Appels manqu\u00e9s par mois', missed, setMissed, 5, 300, 5, '', ' appels'], ['Taux de conclusion des appels r\u00e9pondus', close, setClose, 5, 90, 1, '', '%']].map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 8),
      label = _ref2[0],
      v = _ref2[1],
      set = _ref2[2],
      min = _ref2[3],
      max = _ref2[4],
      step = _ref2[5],
      pre = _ref2[6],
      suf = _ref2[7];
    return React.createElement("div", {
      key: label
    }, React.createElement("div", {
      style: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 14,
        marginBottom: 10
      }
    }, React.createElement("span", {
      style: {
        fontSize: 'var(--fs-label)',
        letterSpacing: '.1em',
        textTransform: 'uppercase',
        fontWeight: 800,
        color: 'var(--text-inverse-muted)'
      }
    }, label), React.createElement("label", {
      style: {
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        padding: '6px 10px',
        borderRadius: 'var(--radius-sm)',
        border: '1px solid var(--border-inverse)',
        background: 'rgba(255,255,255,.06)',
        flex: 'none'
      }
    }, pre ? React.createElement("span", {
      style: {
        fontSize: 18,
        fontWeight: 800,
        color: 'var(--wb-cream)'
      }
    }, pre) : null, React.createElement("input", {
      type: "number",
      min: min,
      max: max,
      step: step,
      value: v,
      "aria-label": label,
      onChange: function onChange(e) {
        var x = e.target.value;
        if (x === '') return;
        var nx = +x;
        if (Number.isNaN(nx)) return;
        set(nx > max ? max : nx);
      },
      onBlur: function onBlur(e) {
        var nx = +e.target.value;
        set(Number.isNaN(nx) ? min : Math.min(max, Math.max(min, nx)));
      },
      onKeyDown: function onKeyDown(e) {
        if (e.key === 'Enter') e.currentTarget.blur();
      },
      style: {
        width: pre === '$' ? 78 : 56,
        border: 'none',
        outline: 'none',
        background: 'transparent',
        fontFamily: 'inherit',
        fontSize: 19,
        fontWeight: 800,
        color: 'var(--wb-cream)',
        textAlign: 'right',
        fontVariantNumeric: 'tabular-nums'
      }
    }), suf ? React.createElement("span", {
      style: {
        fontSize: 14,
        fontWeight: 700,
        color: 'var(--text-inverse-muted)'
      }
    }, suf) : null)), React.createElement("input", {
      type: "range",
      min: min,
      max: max,
      step: step,
      value: v,
      onChange: function onChange(e) {
        return set(+e.target.value);
      },
      style: {
        width: '100%'
      }
    }));
  }), React.createElement("p", {
    style: {
      fontSize: 13,
      color: 'var(--text-inverse-muted)'
    }
  }, "Estimations seulement. Les chiffres montrent une occasion potentielle selon les donn\u00e9es ci-dessus, et non un revenu garanti."))), React.createElement("div", null, React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 12
    }
  }, rows.map(function (_ref3, i) {
    var _ref4 = _slicedToArray(_ref3, 3),
      label = _ref4[0],
      rev = _ref4[1],
      bk = _ref4[2];
    return React.createElement("div", {
      key: label,
      style: {
        background: 'linear-gradient(165deg,rgba(64,32,20,.92) 0%,rgba(40,20,12,.94) 100%)',
        padding: '26px 24px',
        borderRadius: 'var(--radius-lg)',
        border: '1px solid rgba(255,214,170,.14)',
        boxShadow: 'inset 0 1px 0 rgba(255,214,170,.16),inset 0 -1px 0 rgba(0,0,0,.5),0 18px 34px rgba(38,9,2,.4)'
      }
    }, React.createElement("span", {
      style: {
        fontSize: 'var(--fs-label)',
        letterSpacing: '.14em',
        textTransform: 'uppercase',
        fontWeight: 800,
        color: 'var(--text-inverse-muted)'
      }
    }, label), React.createElement("div", {
      style: {
        fontSize: i === 3 ? 38 : 32,
        fontWeight: 800,
        letterSpacing: '-.03em',
        marginTop: 12,
        background: 'var(--grad-brand)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent'
      }
    }, calcMoney(rev)), React.createElement("div", {
      style: {
        fontSize: 14,
        color: 'var(--wb-cream)',
        marginTop: 6,
        fontWeight: 600
      }
    }, Math.round(bk), " nouvelles r\u00e9servations potentielles"));
  })), React.createElement("div", {
    style: {
      display: 'flex',
      gap: 14,
      marginTop: 26,
      alignItems: 'center'
    }
  }, React.createElement(Button, {
    variant: "primary",
    size: "lg",
    arrow: true,
    href: window.WB_PRODUCT_HREF ? window.WB_PRODUCT_HREF('home', 'recover-this-with-an-ai-phone') : '#products'
  }, "R\u00e9cup\u00e9rez \u00e7a avec un AI Phone"), React.createElement("span", {
    className: "mono",
    style: {
      color: 'var(--text-inverse-muted)'
    }
  }, "Occasion de revenu approximative / potentielle"))))));
}
var COVERAGE_DAYS = ['Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam', 'Dim'];
var COVERAGE_TICKS = ['0 h', '3 h', '6 h', '9 h', '12 h', '15 h', '18 h', '21 h', '0 h'];
function CoverageGrid() {
  return React.createElement("div", {
    className: "wb-sync",
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 18
    }
  }, React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'auto minmax(0,1fr)',
      columnGap: 14,
      rowGap: 5,
      alignItems: 'center'
    }
  }, React.createElement("span", null), React.createElement("div", {
    className: "wb-in-up",
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      marginTop: 0,
      animationDelay: '.12s'
    }
  }, React.createElement("span", {
    className: "mono",
    style: {
      fontSize: 14,
      fontWeight: 700,
      letterSpacing: '.08em',
      color: 'var(--wb-orange)',
      marginBottom: 6,
      whiteSpace: 'nowrap'
    }
  }, "AI PHONE \u00b7 24 HEURES SUR 24, 7 JOURS SUR 7"), React.createElement("div", {
    style: {
      width: '100%',
      height: 14,
      borderLeft: '3px solid var(--wb-orange)',
      borderRight: '3px solid var(--wb-orange)',
      borderTop: '3px solid var(--wb-orange)',
      borderRadius: '8px 8px 0 0'
    }
  })), React.createElement("span", null), React.createElement("div", {
    className: "wb-in-up",
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(24,minmax(0,1fr))',
      marginTop: 6,
      animationDelay: '.08s'
    }
  }, React.createElement("div", {
    style: {
      gridColumn: '10 / span 8',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    }
  }, React.createElement("span", {
    className: "mono",
    style: {
      fontSize: 14,
      fontWeight: 700,
      letterSpacing: '.08em',
      color: 'var(--wb-charcoal)',
      marginBottom: 6,
      whiteSpace: 'nowrap'
    }
  }, "VOTRE \u00c9QUIPE \u00b7 9 H\u201317 H, LUN\u2013VEN"), React.createElement("div", {
    style: {
      width: '100%',
      height: 12,
      borderLeft: '3px solid var(--wb-charcoal)',
      borderRight: '3px solid var(--wb-charcoal)',
      borderTop: '3px solid var(--wb-charcoal)',
      borderRadius: '8px 8px 0 0'
    }
  }))), COVERAGE_DAYS.map(function (d, r) {
    return React.createElement(React.Fragment, {
      key: d
    }, React.createElement("span", {
      className: "mono",
      style: {
        fontSize: 12,
        fontWeight: 700,
        letterSpacing: '.1em',
        color: 'var(--ink-500)',
        textAlign: 'right'
      }
    }, d.toUpperCase()), React.createElement("div", {
      style: {
        display: 'grid',
        gridTemplateColumns: 'repeat(24,minmax(0,1fr))',
        gap: 5
      }
    }, Array.from({
      length: 24
    }, function (_, h) {
      var human = r < 5 && h >= 9 && h < 17;
      return React.createElement("span", {
        key: h,
        className: "wb-wave",
        title: d + ' ' + String(h).padStart(2, '0') + ":00 · " + (human ? 'Votre \u00e9quipe' : 'AI Phone'),
        style: {
          aspectRatio: '1',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderRadius: 7,
          background: human ? 'var(--wb-charcoal)' : 'linear-gradient(135deg,var(--wb-gold),var(--wb-orange))',
          animationDelay: ((h + r * 0.9) * 0.018).toFixed(3) + 's'
        }
      }, React.createElement("span", {
        "aria-hidden": "true",
        style: {
          width: '62%',
          height: '62%',
          background: 'var(--wb-white)',
          opacity: human ? .92 : .95,
          WebkitMaskImage: 'url(' + (window.__wbFix || function (u) {
            return u;
          })(human ? ICONS + 'person-check.png' : A + 'orbit.png') + ')',
          maskImage: 'url(' + (window.__wbFix || function (u) {
            return u;
          })(human ? ICONS + 'person-check.png' : A + 'orbit.png') + ')',
          WebkitMaskSize: 'contain',
          maskSize: 'contain',
          WebkitMaskPosition: 'center',
          maskPosition: 'center',
          WebkitMaskRepeat: 'no-repeat',
          maskRepeat: 'no-repeat'
        }
      }));
    })));
  }), React.createElement("span", null), React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(8,minmax(0,1fr))',
      marginTop: 6
    }
  }, COVERAGE_TICKS.map(function (t, k) {
    return React.createElement("span", {
      key: k,
      className: 'mono wb-tick' + (k % 2 ? ' wb-tick-odd' : ''),
      style: {
        fontSize: 11.5,
        letterSpacing: '.08em',
        color: 'var(--ink-500)',
        gridRow: 1,
        gridColumn: k === 8 ? '8' : String(k + 1),
        justifySelf: k === 8 ? 'end' : 'start',
        transform: k === 0 ? 'none' : k === 8 ? 'none' : 'translateX(-50%)'
      }
    }, t);
  }))), React.createElement("div", {
    className: "wb-in-up",
    style: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: '10px 30px',
      alignItems: 'center',
      justifyContent: 'center',
      animationDelay: '.18s'
    }
  }, [['var(--wb-charcoal)', ICONS + 'person-check.png', 'Votre \u00e9quipe travaille 40 heures par semaine.'], ['linear-gradient(135deg,var(--wb-gold),var(--wb-orange))', A + 'orbit.png', 'L\u2019AI Phone r\u00e9pond \u00e0 vos appels pendant les 128 heures restantes de la semaine.']].map(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 3),
      bg = _ref6[0],
      src = _ref6[1],
      l = _ref6[2];
    return React.createElement("span", {
      key: l,
      style: {
        display: 'flex',
        alignItems: 'center',
        gap: 10
      }
    }, React.createElement("span", {
      style: {
        width: 26,
        height: 26,
        borderRadius: 7,
        background: bg,
        flex: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }
    }, React.createElement("img", {
      src: src,
      alt: "",
      "aria-hidden": "true",
      style: {
        width: '62%',
        height: '62%',
        objectFit: 'contain',
        filter: 'brightness(0) invert(1)'
      }
    })), React.createElement("span", {
      style: {
        fontSize: 15,
        fontWeight: 700,
        color: 'var(--text-secondary)'
      }
    }, l));
  })));
}
function Effect() {
  return React.createElement(Section, {
    id: "winboost-effect"
  }, React.createElement(Head, {
    index: "09",
    label: "L\u2019effet WinBoost",
    title: React.createElement(React.Fragment, null, React.createElement("span", {
      style: {
        background: 'linear-gradient(100deg,var(--wb-gold),var(--wb-orange))',
        WebkitBackgroundClip: 'text',
        backgroundClip: 'text',
        color: 'transparent'
      }
    }, "Desire to WIN (d\u00e9sir\u00a0de\u00a0gagner)\u00a0:"), " avec le WinBoost AI Phone, vous \u00eates disponible 24/7. \u00c7a fait 720 heures par mois contre 160 heures pour vos heures d\u2019ouverture de 9 h \u00e0 17 h. C\u2019est 4,5 fois plus de clients, et plus de revenus!")
  }), React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'minmax(0,1fr)',
      gap: 32
    }
  }, React.createElement(Card, {
    surface: "cream",
    padding: "lg",
    radius: "xl",
    style: {
      position: 'relative',
      overflow: 'hidden'
    }
  }, React.createElement(PatternBackdrop, {
    pattern: "radial-burst",
    width: 240,
    opacity: .28,
    basePath: PAT,
    style: {
      position: 'absolute',
      right: -90,
      bottom: -80
    }
  }), React.createElement("div", {
    style: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      gap: 26
    }
  }, React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 6
    }
  }, React.createElement("span", {
    className: "wb-label",
    style: {
      color: 'var(--wb-orange)'
    }
  }, "Une semaine de couverture, heure par heure"), React.createElement("p", {
    style: {
      fontSize: 17,
      lineHeight: 1.55,
      color: 'var(--text-secondary)',
      margin: 0,
      fontWeight: 600
    }
  }, "Votre \u00e9quipe garde les heures qu\u2019elle travaille d\u00e9j\u00e0. L\u2019AI Phone couvre toutes les heures autour, pour que rien ne sonne dans le vide \u00e0 21 h ou le dimanche. C\u2019est aussi une fa\u00e7on intelligente de pr\u00e9senter chaque nouveau lead \u00e0 votre entreprise\u00a0: la premi\u00e8re voix qu\u2019il entend conna\u00eet vos services, vos tarifs et vos disponibilit\u00e9s, et r\u00e9pond en quelques secondes.")), React.createElement(CoverageGrid, null), React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 16,
      paddingTop: 24,
      borderTop: '1px solid var(--sand-300)'
    }
  }, React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 6
    }
  }, React.createElement("span", {
    className: "wb-label",
    style: {
      color: 'var(--wb-orange)'
    }
  }, "Boostez votre SEO local + GEO"), React.createElement("p", {
    style: {
      fontSize: 17,
      lineHeight: 1.55,
      color: 'var(--text-secondary)',
      margin: 0,
      fontWeight: 600
    }
  }, "R\u00e9pondre \u00e0 chaque appel est d\u00e9sormais un signal de classement. Google tient compte de la r\u00e9activit\u00e9, du nombre d\u2019avis et des r\u00e9servations r\u00e9alis\u00e9es pour d\u00e9cider quelle entreprise locale afficher en premier, et les assistants d\u2019IA s\u2019appuient sur les m\u00eames signaux quand on leur demande une recommandation \u00e0 proximit\u00e9. Un t\u00e9l\u00e9phone qui ne reste jamais sans r\u00e9ponse alimente les trois.")), React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(220px,1fr))',
      gap: 20
    }
  }, [['Les appels manqu\u00e9s ne fuient plus', 'Chaque appelant a une vraie conversation, alors le lead ne file jamais vers le r\u00e9sultat suivant dans la carte.'], ['Plus d\u2019avis, en pilote automatique', 'L\u2019AI Phone fait le suivi apr\u00e8s le travail et demande l\u2019avis, le levier de classement local le plus puissant que vous contr\u00f4lez.'], ['Couverture de tous vos territoires desservis', 'Un seul num\u00e9ro r\u00e9pond pour chaque ville, banlieue et code postal que vous desservez, dans la langue de l\u2019appelant.'], ['Des r\u00e9ponses que les assistants d\u2019IA peuvent citer', 'Vos heures, vos services, vos tarifs et votre lien de r\u00e9servation sont \u00e9nonc\u00e9s de fa\u00e7on coh\u00e9rente \u00e0 chaque appel et dans chaque transcription.']].map(function (_ref7) {
    var _ref8 = _slicedToArray(_ref7, 2),
      t = _ref8[0],
      d = _ref8[1];
    return React.createElement("div", {
      key: t,
      style: {
        display: 'flex',
        flexDirection: 'column',
        gap: 6
      }
    }, React.createElement("span", {
      style: {
        fontSize: 15,
        fontWeight: 800,
        color: 'var(--ink-700)',
        letterSpacing: '-.01em'
      }
    }, t), React.createElement("span", {
      style: {
        fontSize: 14.5,
        lineHeight: 1.5,
        color: 'var(--text-secondary)'
      }
    }, d));
  }))), React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'minmax(0,1fr) auto minmax(0,1fr)',
      alignItems: 'center',
      gap: 28,
      paddingTop: 24,
      borderTop: '1px solid var(--sand-300)',
      maxWidth: 680,
      margin: '0 auto',
      width: '100%',
      textAlign: 'center',
      justifyItems: 'center'
    }
  }, React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 14
    }
  }, React.createElement("div", {
    style: {
      width: 152,
      height: 230,
      display: 'grid',
      placeItems: 'center'
    }
  }, React.createElement(Orbit, {
    size: 140,
    state: "listening",
    detail: true,
    volume: true,
    basePath: A
  })), React.createElement(StatBlock, {
    value: "720 h/ mois",
    label: "disponibilit\u00e9 de l\u2019AI Phone",
    caption: "Chaque mois, sans horaire de quarts."
  })), React.createElement("span", {
    className: "wb-label",
    style: {
      color: 'var(--ink-400)',
      fontSize: 28,
      letterSpacing: '.14em'
    }
  }, "VS"), React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 14
    }
  }, React.createElement("div", {
    style: {
      width: 152,
      height: 230,
      borderRadius: 'var(--radius-lg)',
      overflow: 'hidden',
      background: 'var(--sand-200)'
    }
  }, React.createElement("video", {
    src: "assets/receptionist.mp4",
    autoPlay: true,
    muted: true,
    loop: true,
    playsInline: true,
    "aria-label": "Une r\u00e9ceptionniste qui prend les appels",
    style: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      display: 'block'
    }
  })), React.createElement(StatBlock, {
    value: "160 h/ mois",
    label: "Disponibilit\u00e9 humaine",
    tone: "ink",
    caption: "Un horaire typique \u00e0 temps plein."
  }))), React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 14,
      paddingTop: 24,
      borderTop: '1px solid var(--sand-300)',
      textAlign: 'center',
      alignItems: 'center',
      maxWidth: 820,
      margin: '0 auto'
    }
  }, React.createElement("span", {
    className: "wb-label",
    style: {
      color: 'var(--wb-orange)'
    }
  }, "Toujours actif"), React.createElement("h3", {
    style: {
      fontSize: 'var(--fs-h2)',
      lineHeight: 1.1,
      letterSpacing: '-.03em',
      fontWeight: 800,
      color: 'var(--wb-charcoal)',
      margin: 0
    }
  }, "Votre entreprise ne ferme plus jamais."), React.createElement("p", {
    style: {
      fontSize: 17,
      lineHeight: 1.6,
      color: 'var(--text-secondary)',
      fontWeight: 600,
      margin: 0
    }
  }, "Avec votre AI Phone reli\u00e9 \u00e0 votre entreprise, vous offrez un service \u00e0 la client\u00e8le 24/7, l\u2019une des nombreuses fa\u00e7ons de faire cro\u00eetre vos revenus. \u00c7a fait 8\u00a0640 heures contre 1\u00a0920 heures par ann\u00e9e, soit 6\u00a0720 heures de plus pour capter, engager et convertir des occasions. Plus d\u2019occasions. Plus de conversions. C\u2019est l\u2019effet WinBoost.")), React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(4,minmax(0,1fr))',
      gap: 28,
      paddingTop: 24,
      borderTop: '1px solid var(--sand-300)'
    }
  }, [['24/7', 'R\u00e9ponse', 'Nuits, fins de semaine, jours f\u00e9ri\u00e9s'], ['99,9\u00a0%', 'Disponibilit\u00e9', 'Acheminement redondant par plusieurs op\u00e9rateurs'], ['1st', 'R\u00e9ponse d\u00e8s la sonnerie', 'Pas de file d\u2019attente, pas de musique d\u2019attente']].map(function (_ref9) {
    var _ref0 = _slicedToArray(_ref9, 3),
      v = _ref0[0],
      l = _ref0[1],
      c = _ref0[2];
    return React.createElement(StatBlock, {
      key: v,
      value: v,
      label: l,
      tone: "success",
      caption: c
    });
  }), React.createElement(StatBlock, {
    value: "4,5\u00d7",
    label: "Plus de disponibilit\u00e9",
    tone: "success",
    caption: "6\u00a0720 heures de plus par ann\u00e9e."
  })), React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'center'
    }
  }, React.createElement(Button, {
    variant: "primary",
    size: "lg",
    arrow: true,
    href: window.WB_PRODUCT_HREF ? window.WB_PRODUCT_HREF('home', 'get-your-ai-phone') : '#final-form'
  }, "Obtenez votre AI Phone"))))));
}
function DataSafe() {
  return React.createElement(Section, {
    id: "data-safe",
    tight: true
  }, React.createElement(Card, {
    surface: "white",
    padding: "lg",
    radius: "xl"
  }, React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'minmax(0,1fr) minmax(0,1.15fr)',
      gap: 'clamp(24px,3vw,52px)',
      alignItems: 'start'
    }
  }, React.createElement("h3", {
    style: {
      gridColumn: '1 / -1',
      fontSize: 'var(--fs-h3)',
      fontWeight: 800,
      margin: 0
    }
  }, "Vos donn\u00e9es sont en s\u00e9curit\u00e9, et elles restent les v\u00f4tres."), React.createElement("div", null, React.createElement("p", {
    style: {
      fontSize: 15,
      color: 'var(--text-secondary)',
      margin: 0
    }
  }, "Les appels et les transcriptions sont chiffr\u00e9s en transit et au repos, ce qui signifie que personne \u00e0 l\u2019ext\u00e9rieur de votre entreprise ne peut les lire. Ils sont stock\u00e9s dans votre portail et votre \u00e9cosyst\u00e8me d\u2019entreprise, et ne servent jamais \u00e0 entra\u00eener des mod\u00e8les externes. Le stockage est illimit\u00e9, alors chaque appel que vous avez pris reste en s\u00e9curit\u00e9 et accessible.")), React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(210px,1fr))',
      gap: 14
    }
  }, React.createElement(CheckItem, null, "Stockage chiffr\u00e9 des appels"), React.createElement(CheckItem, null, "Toutes vos donn\u00e9es dans un seul portail"), React.createElement(CheckItem, null, "Acheminement redondant par plusieurs op\u00e9rateurs"), React.createElement(CheckItem, null, "Transfert \u00e0 un humain sur demande"), React.createElement(CheckItem, null, "Stockage de donn\u00e9es illimit\u00e9"), React.createElement(CheckItem, null, "Transcription compl\u00e8te de chaque appel"), React.createElement(CheckItem, null, "Chiffrement de bout en bout de chaque appel"), React.createElement(CheckItem, null, "Transparence totale sur ce qui est stock\u00e9")))));
}
var OLD = ['Menu t\u00e9l\u00e9phonique et musique d\u2019attente', 'Bo\u00eete vocale apr\u00e8s les heures d\u2019ouverture', 'Rappels manuels le lendemain matin', 'Leads relanc\u00e9s quand quelqu\u2019un a le temps', 'Difficile de retracer ce qui a \u00e9t\u00e9 dit', 'Personne n\u2019aime interagir avec \u00e7a'];
var NEW = ['Conversation naturelle d\u00e8s la premi\u00e8re sonnerie', 'R\u00e9ponse 24/7, fins de semaine comprises', 'Inscrit dans votre calendrier pendant l\u2019appel', 'Suivi par texto envoy\u00e9 automatiquement', 'Multilingue, dans toutes les langues de vos appelants', 'Transcription', 'Les appelants aiment vraiment lui parler'];
var CALL_OUTCOMES = [['R\u00e9pond \u00e0 toutes les questions', 'R\u00e9ponse', '\u00ab\u00a0Combien co\u00fbte une couronne, et \u00eates-vous ouverts samedi?\u00a0\u00bb', '\u00ab\u00a0Les couronnes commencent \u00e0 1\u00a0150\u00a0$, et oui, le samedi de 9 h \u00e0 14 h. Voulez-vous que je v\u00e9rifie ce samedi?\u00a0\u00bb', ['Question r\u00e9pondue en 11 secondes', 'Tarifs et heures tir\u00e9s de vos propres r\u00e9ponses', 'L\u2019appelant est rest\u00e9 en ligne']], ['R\u00e9serve la rencontre', 'R\u00e9servation', '\u00ab\u00a0Jeudi matin m\u2019irait mieux.\u00a0\u00bb', '\u00ab\u00a0Jeudi \u00e0 10 h 30, c\u2019est libre. C\u2019est r\u00e9serv\u00e9, et la confirmation s\u2019en vient.\u00a0\u00bb', ['Plage inscrite dans votre calendrier', 'Confirmation par texto envoy\u00e9e', 'Pas d\u2019allers-retours, pas de bo\u00eete vocale']], ['Fait une r\u00e9servation', 'Reserving', '\u00ab\u00a0Une table pour quatre ce soir, vers dix-neuf heures?\u00a0\u00bb', '\u00ab\u00a0Dix-neuf heures pour quatre est r\u00e9serv\u00e9 \u00e0 votre nom. \u00c0 ce soir.\u00a0\u00bb', ['R\u00e9servation confirm\u00e9e sur-le-champ', 'Nombre de personnes et heure not\u00e9s', 'Rappel par texto planifi\u00e9']], ['Transf\u00e8re l\u2019appel', 'Transferring', '\u00ab\u00a0J\u2019ai besoin de parler \u00e0 quelqu\u2019un au sujet de ma facture.\u00a0\u00bb', '\u00ab\u00a0Je vous transf\u00e8re \u00e0 la comptabilit\u00e9 tout de suite. Un instant.\u00a0\u00bb', ['Dirig\u00e9 vers la bonne personne', 'Contexte transmis avec l\u2019appel', 'Pas besoin de r\u00e9p\u00e9ter son histoire']], ['Conclut la vente', 'Selling', '\u00ab\u00a0D\u2019accord, allons-y avec le forfait annuel.\u00a0\u00bb', '\u00ab\u00a0C\u2019est fait. Forfait annuel confirm\u00e9, et je vous ai envoy\u00e9 le re\u00e7u par courriel.\u00a0\u00bb', ['Commande prise pendant l\u2019appel', 'Lien de paiement livr\u00e9 par texto', 'Vente consign\u00e9e dans votre CRM']], ['G\u00e8re les objections', 'Objection', '\u00ab\u00a0Honn\u00eatement, \u00e7a semble cher.\u00a0\u00bb', '\u00ab\u00a0La plupart des clients comparent \u00e7a \u00e0 un seul contrat manqu\u00e9 par mois. Voulez-vous que je vous explique les chiffres?\u00a0\u00bb', ['Objection trait\u00e9e, pas esquiv\u00e9e', 'L\u2019appelant reste dans la conversation', 'Suivi r\u00e9serv\u00e9 plut\u00f4t que perdu']]];
var CFL_CSS = '.cfl{background:#171717;border-radius:var(--radius-xl);padding:20px 18px 18px;display:flex;flex-direction:column;gap:14px;overflow:hidden;color:#FBFAF7}' + '.cfl-abil{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:8px}' + '.cfl-ab{display:flex;align-items:center;justify-content:center;text-align:center;overflow-wrap:break-word;min-height:38px;padding:6px 8px;border-radius:12px;border:1px solid #3A3A3A;background:rgba(255,255,255,.04);color:#9d9d9d;font-size:12px;line-height:1.2;font-weight:700;transition:all .35s}' + '.cfl-ab.done{color:#FBFAF7}.cfl-ab.on{background:linear-gradient(135deg,#FFAE06,#FC6306);border-color:transparent;color:#171717;transform:scale(1.03)}' + '.cfl-strip{display:grid;grid-template-columns:auto minmax(0,1fr) auto;align-items:center;gap:6px;padding-top:4px}' + '.cfl-end{display:flex;flex-direction:column;align-items:center;gap:8px;width:72px}' + '.cfl-ph{width:44px;height:44px;border-radius:50%;border:1px solid #3A3A3A;background:rgba(255,255,255,.06);display:flex;align-items:center;justify-content:center;font-size:19px;color:#FBFAF7;position:relative;transition:box-shadow .3s,border-color .3s}' + '.cfl-ph i{position:absolute;inset:-1px;border-radius:50%;border:2px solid #FFAE06;opacity:0}' + '.cfl-ring .cfl-ph i{animation:cflRg 1.3s ease-out infinite}.cfl-ring .cfl-ph i:nth-child(2){animation-delay:.43s}.cfl-ring .cfl-ph i:nth-child(3){animation-delay:.86s}' + '@keyframes cflRg{0%{transform:scale(1);opacity:.7}100%{transform:scale(1.8);opacity:0}}' + '.cfl-say-c .cfl-ph{border-color:#FFAE06;box-shadow:0 0 0 5px rgba(255,174,6,.16),0 0 18px rgba(255,174,6,.35)}' + '.cfl-orbw{width:72px;height:72px;transition:transform .35s,filter .35s}' + '.cfl-say-c .cfl-orbw{transform:scale(1.03);filter:drop-shadow(0 0 8px rgba(255,174,6,.3))}' + '.cfl-think .cfl-orbw{animation:cflBr .9s ease-in-out infinite alternate}' + '@keyframes cflBr{from{transform:scale(.96);filter:drop-shadow(0 0 4px rgba(255,174,6,.2))}to{transform:scale(1.04);filter:drop-shadow(0 0 12px rgba(255,174,6,.5))}}' + '.cfl-say-a .cfl-orbw{transform:scale(1.08);filter:drop-shadow(0 0 16px rgba(255,174,6,.6))}' + '.cfl-lane{position:relative;height:44px}' + '.cfl-ln{position:absolute;left:0;right:0;top:50%;height:2px;transform:translateY(-50%);border-radius:2px;background:repeating-linear-gradient(90deg,rgba(255,255,255,.3) 0 6px,transparent 6px 12px);opacity:.6;transition:opacity .4s}' + '.cfl-live .cfl-ln{background:linear-gradient(90deg,rgba(255,255,255,.1),#FFAE06 40%,#FC6306);opacity:1}' + '.cfl-pk{position:absolute;top:50%;width:9px;height:9px;margin:-4.5px 0 0 -4.5px;border-radius:50%;background:#FFAE06;box-shadow:0 0 12px 2px rgba(255,174,6,.75);opacity:0}' + '.cfl-slot{height:40px;display:flex;justify-content:center}' + '.cfl-pop{display:inline-grid;align-items:center;justify-items:center;border:1px dashed rgba(255,255,255,.3);border-radius:999px;padding:0 16px;min-height:38px;font-size:13px;line-height:1.2;font-weight:800;color:#9d9d9d;transition:border-color .4s,background .4s,color .4s}' + '.cfl-pw,.cfl-pr{grid-area:1/1;transition:opacity .35s}' + '.cfl-pw{display:inline-flex;align-items:center;gap:8px;text-align:center;padding:6px 0}' + '.cfl-td{display:inline-flex;gap:3px}.cfl-td u{width:5px;height:5px;border-radius:50%;background:#FFAE06;opacity:.3;animation:cflTd 1.1s infinite}.cfl-td u:nth-child(2){animation-delay:.18s}.cfl-td u:nth-child(3){animation-delay:.36s}' + '@keyframes cflTd{0%,100%{opacity:.25}50%{opacity:1}}' + '@property --cfl-a{syntax:"<angle>";initial-value:0deg;inherits:false}' + '.cfl-pop:not(.show){position:relative;border:1px solid transparent;animation:cflGl 1.8s ease-in-out infinite}' + '.cfl-pop:not(.show):before{content:"";position:absolute;inset:-1px;border-radius:inherit;padding:1px;background:conic-gradient(from var(--cfl-a),rgba(255,174,6,.08),#FFAE06 18%,#FC6306 34%,rgba(252,99,6,.08) 55%,rgba(255,174,6,.08));-webkit-mask:linear-gradient(#000 0 0) content-box,linear-gradient(#000 0 0);-webkit-mask-composite:xor;mask-composite:exclude;pointer-events:none;animation:cflSp 2.4s linear infinite,cflPb 1.8s ease-in-out infinite}' + '@keyframes cflSp{to{--cfl-a:360deg}}' + '@keyframes cflPb{0%,100%{opacity:.6}50%{opacity:1}}' + '@keyframes cflGl{0%,100%{box-shadow:0 0 0 0 rgba(255,174,6,0)}50%{box-shadow:0 0 16px 0 rgba(255,174,6,.22)}}' + '.cfl-pr{display:inline-flex;align-items:center;gap:9px;opacity:0;white-space:normal;text-align:left}' + '.cfl-pop.show{border:1px solid rgba(255,174,6,.55);background:rgba(255,255,255,.07);color:#FBFAF7;padding:0 14px 0 9px;animation:cflPop .5s cubic-bezier(.2,1.3,.4,1)}' + '.cfl-pop.show .cfl-pw{opacity:0}.cfl-pop.show .cfl-pr{opacity:1}' + '@keyframes cflPop{from{transform:scale(.9)}to{transform:none}}' + '.cfl-pr b{flex:none;width:20px;height:20px;border-radius:50%;background:linear-gradient(135deg,#FFAE06,#FC6306);color:#171717;font-size:12px;display:inline-flex;align-items:center;justify-content:center}' + '.cfl hr{border:0;border-top:1px solid #3A3A3A;margin:0}' + '.cfl-live-row{display:flex;align-items:center;gap:12px}' + '.cfl-badge{display:inline-flex;align-items:center;gap:8px;background:rgba(255,255,255,.08);border:1px solid #3A3A3A;border-radius:999px;padding:7px 13px;font-size:12.5px;font-weight:800;white-space:nowrap}' + '.cfl-badge i{width:8px;height:8px;border-radius:50%;background:#34a853;animation:cflPu 1.8s infinite}' + '@keyframes cflPu{0%,100%{opacity:.55}50%{opacity:1}}' + '.cfl-tr{display:flex;flex-direction:column;gap:10px}' + '.cfl-turn{display:flex;flex-direction:column;gap:5px;max-width:90%;transition:opacity .4s}' + '.cfl-turn.a{align-self:flex-end;align-items:flex-end}.cfl-turn.dim{opacity:.55}.cfl-turn.pre{visibility:hidden}' + '.cfl-bub{font-size:15px;line-height:1.5;color:#FBFAF7;border-radius:12px;padding:10px 13px;text-align:left}' + '.cfl-turn.c .cfl-bub{background:rgba(255,255,255,.06);border:1px solid #3A3A3A;border-top-left-radius:4px}' + '.cfl-turn.a .cfl-bub{background:rgba(244,138,29,.16);border:1px solid #FC6306;font-weight:700;border-top-right-radius:4px}' + '.cfl-w{opacity:0;transition:opacity .25s}.cfl-w.on{opacity:1}' + '@media (max-width:420px){.cfl{padding:18px 14px}.cfl-ab{font-size:11px;padding:6px 3px;min-height:40px}.cfl-abil{gap:6px}}@media (max-width:345px){.cfl{padding:16px 12px}.cfl-abil{grid-template-columns:repeat(2,minmax(0,1fr))}.cfl-ab{font-size:11.5px;padding:6px 4px;min-height:36px}}' + '@media (prefers-reduced-motion:reduce){.cfl-td u,.cfl-pop:not(.show),.cfl-pop:not(.show):before,.cfl-ring .cfl-ph i,.cfl-badge i,.cfl-think .cfl-orbw{animation:none}}';
var CFL_T = {
  ANS: 1.5,
  C: 2.0,
  CEND: 4.4,
  A: 5.1,
  AEND: 8.6,
  POP: 8.8,
  NEXT: 11.6
};
function CallFlow() {
  var _React$useState7 = React.useState(0),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    k = _React$useState8[0],
    setK = _React$useState8[1];
  var _React$useState9 = React.useState({
      ring: true,
      sc: false,
      think: false,
      sa: false,
      nc: 0,
      na: 0,
      pop: false,
      cpre: true,
      apre: true,
      cdim: false
    }),
    _React$useState0 = _slicedToArray(_React$useState9, 2),
    s = _React$useState0[0],
    setS = _React$useState0[1];
  var root = React.useRef(null),
    pk = React.useRef(null);
  React.useEffect(function () {
    var el = root.current;
    if (!el) return;
    var T = CFL_T,
      reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var raf = 0,
      run = false,
      last = 0,
      t = 0,
      idx = 0,
      key = '';
    var wc = function wc(x) {
      return x.split(' ').length;
    };
    var snap = function snap() {
      var o = CALL_OUTCOMES[idx];
      var cn = Math.max(0, Math.min(1, (t - T.C) / (T.CEND - T.C - .3))),
        an = Math.max(0, Math.min(1, (t - T.A) / (T.AEND - T.A - .3)));
      var nc = t < T.C ? 0 : Math.ceil(cn * wc(o[2])),
        na = t < T.A ? 0 : Math.ceil(an * wc(o[3]));
      var sc = t >= T.C && t < T.CEND,
        think = t >= T.CEND && t < T.A,
        sa = t >= T.A && t < T.AEND;
      var n = {
        ring: t < T.ANS,
        sc: sc,
        think: think,
        sa: sa,
        nc: nc,
        na: na,
        pop: t >= T.POP,
        cpre: t < T.C,
        apre: t < T.A,
        cdim: t >= T.A + .6
      };
      var nk = Object.keys(n).map(function (q) {
        return n[q];
      }).join('|');
      if (nk !== key) {
        key = nk;
        setS(n);
      }
      var p = 0,
        op = 0;
      if (sc) {
        var u = (t - T.C) % 1;
        p = u;
        op = Math.sin(Math.PI * u);
      } else if (sa) {
        var _u = (t - T.A) % 1;
        p = 1 - _u;
        op = Math.sin(Math.PI * _u);
      }
      if (pk.current) {
        pk.current.style.left = p * 100 + '%';
        pk.current.style.opacity = op;
      }
    };
    var _frame = function frame(ts) {
      var dt = last ? Math.min(.1, (ts - last) / 1000) : .016;
      last = ts;
      t += dt;
      if (t > T.NEXT) {
        t = 0;
        idx = (idx + 1) % CALL_OUTCOMES.length;
        setK(idx);
      }
      snap();
      if (run) raf = requestAnimationFrame(_frame);
    };
    if (reduce) {
      t = T.POP + .5;
      snap();
      return;
    }
    snap();
    var io = null;
    if (!window.IntersectionObserver) {
      run = true;
      raf = requestAnimationFrame(_frame);
    } else {
      io = new IntersectionObserver(function (e) {
        if (e[0].isIntersecting && !run) {
          run = true;
          last = 0;
          raf = requestAnimationFrame(_frame);
        } else if (!e[0].isIntersecting && run) {
          run = false;
          cancelAnimationFrame(raf);
        }
      }, {
        threshold: 0
      });
      io.observe(el);
    }
    return function () {
      run = false;
      cancelAnimationFrame(raf);
      if (io) io.disconnect();
    };
  }, []);
  var _CALL_OUTCOMES$k = _slicedToArray(CALL_OUTCOMES[k], 5),
    label = _CALL_OUTCOMES$k[0],
    tag = _CALL_OUTCOMES$k[1],
    caller = _CALL_OUTCOMES$k[2],
    ai = _CALL_OUTCOMES$k[3],
    results = _CALL_OUTCOMES$k[4];
  var words = function words(x, n) {
    return x.split(' ').map(function (w, i) {
      return React.createElement("span", {
        key: i,
        className: 'cfl-w' + (i < n ? ' on' : '')
      }, w, ' ');
    });
  };
  var cls = 'cfl ' + (s.ring ? 'cfl-ring ' : 'cfl-live ') + (s.sc ? 'cfl-say-c ' : '') + (s.think ? 'cfl-think ' : '') + (s.sa ? 'cfl-say-a' : '');
  var orbState = s.sa ? 'speaking' : s.think ? 'thinking' : s.sc ? 'listening' : 'breathing';
  return React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 16
    }
  }, React.createElement("style", null, CFL_CSS), React.createElement("div", {
    ref: root,
    className: cls
  }, React.createElement("div", {
    className: "cfl-abil"
  }, CALL_OUTCOMES.map(function (o, i) {
    return React.createElement("div", {
      key: o[0],
      className: 'cfl-ab' + (i === k ? ' on' : i < k ? ' done' : '')
    }, o[0]);
  })), React.createElement("div", {
    className: "cfl-strip"
  }, React.createElement("div", {
    className: "cfl-end"
  }, React.createElement("span", {
    className: "cfl-ph"
  }, React.createElement("i", null), React.createElement("i", null), React.createElement("i", null), "\u260E"), React.createElement("span", {
    className: "mono",
    style: {
      color: 'var(--text-inverse-muted)',
      fontSize: 11
    }
  }, "Appelant")), React.createElement("div", {
    className: "cfl-lane"
  }, React.createElement("span", {
    className: "cfl-ln"
  }), React.createElement("span", {
    className: "cfl-pk",
    ref: pk
  })), React.createElement("div", {
    className: "cfl-end"
  }, React.createElement("div", {
    className: "cfl-orbw"
  }, React.createElement(Orbit, {
    size: 72,
    state: orbState,
    basePath: A
  })), React.createElement("span", {
    className: "mono",
    style: {
      color: 'var(--text-inverse-muted)',
      fontSize: 11
    }
  }, "AI Phone"))), React.createElement("div", {
    className: "cfl-slot"
  }, React.createElement("span", {
    className: 'cfl-pop' + (s.pop ? ' show' : '')
  }, React.createElement("span", {
    className: "cfl-pw"
  }, "Comprendre ce dont l\u2019appelant a besoin", React.createElement("span", {
    className: "cfl-td"
  }, React.createElement("u", null), React.createElement("u", null), React.createElement("u", null))), React.createElement("span", {
    className: "cfl-pr"
  }, React.createElement("b", null, "\u2713"), React.createElement("span", null, results[0])))), React.createElement("hr", null), React.createElement("div", {
    className: "cfl-live-row"
  }, React.createElement("span", {
    className: "cfl-badge"
  }, React.createElement("i", null), tag, " \u00b7 en direct"), React.createElement(SoundRibbon, {
    height: 20,
    active: s.sa,
    style: {
      flex: 1
    }
  })), React.createElement("div", {
    className: "cfl-tr"
  }, React.createElement("div", {
    className: 'cfl-turn c' + (s.cpre ? ' pre' : '') + (s.cdim ? ' dim' : '')
  }, React.createElement("span", {
    className: "mono",
    style: {
      color: 'var(--text-inverse-muted)',
      fontSize: 11
    }
  }, "Appelant"), React.createElement("span", {
    className: "cfl-bub"
  }, words(caller, s.nc))), React.createElement("div", {
    className: 'cfl-turn a' + (s.apre ? ' pre' : '')
  }, React.createElement("span", {
    className: "mono",
    style: {
      color: 'var(--wb-gold)',
      fontSize: 11
    }
  }, "AI"), React.createElement("span", {
    className: "cfl-bub"
  }, words(ai, s.na))))), React.createElement("p", {
    style: {
      fontSize: 14,
      lineHeight: 1.6,
      color: 'var(--text-secondary)'
    }
  }, "Une conversation, six issues possibles. L\u2019appelant ne choisit jamais une option dans un menu. L\u2019AI Phone d\u00e9termine ce dont l\u2019appel a besoin."));
}
function OldVsNew() {
  var _React$useState1 = React.useState('new'),
    _React$useState10 = _slicedToArray(_React$useState1, 2),
    side = _React$useState10[0],
    setSide = _React$useState10[1];
  return React.createElement(Section, {
    id: "compare-old-way",
    style: {
      background: 'var(--wb-white)',
      borderTop: '1px solid var(--border-hairline)',
      borderBottom: '1px solid var(--border-hairline)'
    }
  }, React.createElement(Head, {
    index: "06",
    label: "Maintenant et avant",
    title: "La m\u00e9thode WinBoost et l\u2019ancienne m\u00e9thode.",
    lead: "Le syst\u00e8me t\u00e9l\u00e9phonique de votre entreprise a \u00e9t\u00e9 con\u00e7u il y a des d\u00e9cennies. Comparez-le \u00e0 une seule conversation qui se termine par une r\u00e9servation."
  }), React.createElement("div", {
    style: {
      display: 'flex',
      gap: 10,
      marginBottom: 34
    }
  }, [['new', 'WinBoost AI Phone'], ['old', 'Ancien syst\u00e8me IVR']].map(function (_ref1) {
    var _ref10 = _slicedToArray(_ref1, 2),
      k = _ref10[0],
      l = _ref10[1];
    return React.createElement("button", {
      key: k,
      onClick: function onClick() {
        return setSide(k);
      },
      style: {
        all: 'unset',
        cursor: 'pointer',
        padding: '10px 20px',
        borderRadius: 'var(--radius-md)',
        fontSize: 14,
        fontWeight: 800,
        background: side === k ? k === 'new' ? 'var(--grad-brand)' : 'var(--wb-charcoal)' : 'transparent',
        color: side === k ? '#fff' : 'var(--ink-600)',
        border: '1px solid ' + (side === k ? 'transparent' : 'var(--border-card)')
      }
    }, l);
  })), React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: 1,
      background: 'var(--border-card)',
      border: '1px solid var(--border-card)',
      borderRadius: 'var(--radius-xl)',
      overflow: 'hidden'
    }
  }, React.createElement("div", {
    onClick: function onClick() {
      return setSide('old');
    },
    className: "wb-in-r wb-late",
    style: {
      background: side === 'old' ? 'var(--sand-100)' : 'var(--wb-white)',
      padding: 40,
      opacity: side === 'old' ? 1 : .55,
      cursor: side === 'old' ? 'default' : 'pointer',
      transition: 'opacity var(--dur-base) var(--ease-standard)'
    }
  }, React.createElement("span", {
    className: "wb-label",
    style: {
      color: 'var(--ink-500)'
    }
  }, "L\u2019ancienne m\u00e9thode"), React.createElement("p", {
    style: {
      fontSize: 15,
      fontWeight: 700,
      color: 'var(--ink-600)',
      marginTop: 12
    }
  }, "L\u2019interaction entre client et t\u00e9l\u00e9phone existe depuis 1980 et n\u2019a jamais \u00e9t\u00e9 optimis\u00e9e."), React.createElement("div", {
    style: {
      marginTop: 20,
      borderRadius: 'var(--radius-lg)',
      overflow: 'hidden',
      border: '1px solid var(--sand-300)',
      background: 'var(--wb-white)',
      padding: 12,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, React.createElement("img", {
    src: "assets/old-ivr-flow-gray.png",
    alt: "Un ancien diagramme de flux d\u2019appels IVR\u00a0: des dizaines de cases ramifi\u00e9es pour les transferts, les enregistrements, les \u00e9valuations et les raccrochages",
    style: {
      width: '100%',
      height: 'auto',
      objectFit: 'contain',
      opacity: .9
    }
  })), React.createElement("p", {
    style: {
      fontSize: 14,
      color: 'var(--ink-600)',
      marginTop: 12
    }
  }, "Un arbre d\u2019appels configur\u00e9 case par case. Chaque chemin est script\u00e9 \u00e0 l\u2019avance, et tout ce qui n\u2019est pas script\u00e9 se termine \u00e0 la bo\u00eete vocale."), React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 16,
      marginTop: 24
    }
  }, OLD.map(function (o) {
    return React.createElement("div", {
      key: o,
      style: {
        display: 'flex',
        gap: 12,
        alignItems: 'center'
      }
    }, React.createElement("span", {
      style: {
        width: 20,
        height: 20,
        borderRadius: '50%',
        border: '1.5px solid var(--red-500)',
        color: 'var(--red-500)',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 12,
        fontWeight: 800,
        flex: 'none'
      }
    }, "\xD7"), React.createElement("span", {
      style: {
        fontSize: 15,
        fontWeight: 600,
        color: 'var(--ink-600)'
      }
    }, o));
  }))), React.createElement("div", {
    onClick: function onClick() {
      return setSide('new');
    },
    className: "wb-in-l wb-late",
    style: _objectSpread(_objectSpread({
      background: side === 'new' ? 'linear-gradient(0deg,#FFAE06 0%,#FC6306 100%)' : 'var(--wb-white)'
    }, side === 'new' ? {
      '--text-primary': '#171717',
      '--text-secondary': '#171717',
      '--text-muted': '#2A2A2A'
    } : null), {}, {
      padding: 40,
      opacity: side === 'new' ? 1 : .55,
      cursor: side === 'new' ? 'default' : 'pointer',
      transition: 'opacity var(--dur-base) var(--ease-standard)'
    })
  }, React.createElement("span", {
    className: "wb-label",
    style: side === 'new' ? {
      display: 'inline-flex',
      alignSelf: 'flex-start',
      padding: '7px 14px',
      borderRadius: 999,
      background: '#171717',
      color: '#FFFFFF',
      fontSize: 13,
      fontWeight: 800
    } : {
      color: 'var(--wb-orange)'
    }
  }, "La nouvelle m\u00e9thode\u00a0: WinBoost AI Phone Lead Closer"), React.createElement("p", {
    style: {
      fontSize: side === 'new' ? 19 : 15,
      lineHeight: 1.3,
      fontWeight: 800,
      letterSpacing: '-.01em',
      color: 'var(--text-primary)',
      marginTop: 14
    }
  }, "Flux de travail automatis\u00e9 par l\u2019IA avec des conversations infinies"), React.createElement("div", {
    style: {
      marginTop: 20
    }
  }, React.createElement(CallFlow, null)), React.createElement("div", {
    className: side === 'new' ? 'nw-checks' : undefined,
    style: {
      display: 'flex',
      flexDirection: 'column',
      gap: 16,
      marginTop: 24
    }
  }, NEW.map(function (o) {
    return React.createElement(CheckItem, {
      key: o
    }, o);
  })), side === 'new' ? React.createElement("style", null, '.nw-checks>div>span:first-child{background:#171717!important}') : null, React.createElement("div", {
    style: {
      marginTop: 30,
      paddingTop: 22,
      borderTop: side === 'new' ? '1px solid rgba(23,23,23,.25)' : '1px solid var(--orange-100)'
    }
  }, React.createElement(StatBlock, {
    size: "sm",
    tone: side === 'new' ? 'neutral' : 'accent',
    value: "720 h",
    label: "R\u00e9pondus chaque mois",
    caption: "Nuits, fins de semaine et d\u00e9bordements compris."
  }), React.createElement("p", {
    style: {
      fontSize: 15,
      lineHeight: 1.65,
      color: 'var(--text-secondary)',
      marginTop: 16
    }
  }, "Con\u00e7u pour capter chaque lead qui appelle votre entreprise, et pour vous redonner votre journ\u00e9e. Votre \u00e9quipe consacre ses heures au travail qui a besoin d\u2019elle, et quand elle termine, elle est vraiment en cong\u00e9. Pas d\u2019appels au souper, pas de fins de semaine interrompues\u00a0: vous et vos gens passez du vrai temps avec les gens que vous aimez, pendant que le WinBoost AI Phone s\u2019occupe du reste.")))), React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'center',
      marginTop: 'clamp(18px,2vw,28px)'
    }
  }, React.createElement(Button, {
    variant: "primary",
    size: "lg",
    arrow: true,
    href: window.WB_AGENT_CALL || '#hear-it'
  }, "Appelez le WinBoost AI Phone")));
}
Object.assign(window, {
  Calculator: Calculator,
  Effect: Effect,
  OldVsNew: OldVsNew,
  CallFlow: CallFlow,
  DataSafe: DataSafe
});